import { AppBar, Box, Button, Container, Stack, Toolbar } from "@mui/material";
import type { UserInfo } from "firebase/auth";
import type { FC } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import type { CustomerContext } from "../auth/auth";
import NewUiButton from "./NewUiButton";
import { useSiteMap } from "./Sitemap";
import { TopmostAppBar } from "./TopmostAppBar";

interface NavigationProps {
  readonly context: CustomerContext | null;
}

const Navigation: FC<NavigationProps> = ({ context }) => {
  const navigate = useNavigate();
  const sitemap = useSiteMap(context);
  const location = useLocation();

  return (
    <Stack direction="row" spacing={1} sx={{ width: "100%", alignItems: "center" }}>
      {sitemap.map(({ label, icon, link }) => {
        const active = location.pathname === link;
        return (
          <Button
            key={label}
            color="inherit"
            startIcon={icon}
            onClick={() => navigate(link)}
            aria-current={active ? "page" : undefined}
            sx={{
              opacity: active ? 1 : 0.7,
              fontWeight: active ? "bold" : "normal",
              bgcolor: active ? "rgba(255,255,255,0.15)" : "transparent",
              "&:hover": { bgcolor: "rgba(255,255,255,0.2)" },
            }}
          >
            {label}
          </Button>
        );
      })}
      <NewUiButton />
    </Stack>
  );
};

interface Props {
  readonly context: CustomerContext | null;
  readonly userInfo: UserInfo | null;
}

export const CustomerAppBar: FC<Props> = ({ context, userInfo }) => {
  return (
    <AppBar position="sticky" elevation={0} sx={{ bgcolor: "white", color: "text.primary", borderBottom: "none" }}>
      <TopmostAppBar context={context} userInfo={userInfo} />
      <Box sx={{ bgcolor: "primary.main", color: "white" }}>
        <Container maxWidth="xl">
          <Toolbar
            disableGutters
            sx={{ display: { xs: "none", md: "flex" }, minHeight: "64px !important", overflowX: "auto", py: 1 }}
          >
            <Stack direction="row" spacing={1} sx={{ width: "100%", alignItems: "center" }}>
              <Navigation context={context} />
            </Stack>
          </Toolbar>
        </Container>
      </Box>
    </AppBar>
  );
};

export default CustomerAppBar;
